/** Maximum display length for PR titles on the dashboard */
export const DASHBOARD_TITLE_MAX = 100;

/** Maximum display length for PR titles on the detail page */
export const DETAIL_TITLE_MAX = 120;

/**
 * Truncates a string to the specified maximum length.
 * If the string exceeds maxLength, it is cut and suffixed with "...".
 * If the string is within the limit, it is returned unchanged.
 */
export function truncateTitle(title: string, maxLength: number): string {
  if (title.length <= maxLength) {
    return title;
  }
  return title.slice(0, maxLength) + '...';
}
